import Divider from "../ornaments/Divider.tsx";

export default function SiteFooter() {
  return (
    <footer className="mt-24 border-t border-[var(--color-rule)]/60 bg-[var(--color-dark)] text-[var(--color-cream)]">
      <div className="mx-auto max-w-6xl px-6 py-20 md:px-10">
        <Divider />
        <div className="mt-10 grid gap-12 md:grid-cols-[2fr_1fr_1fr_1fr]">
          <div>
            <p className="font-serif text-3xl font-semibold tracking-[0.18em] text-[var(--color-cream)]">
              BEADORÉ
            </p>
            <p className="mt-2 text-[0.65rem] font-light uppercase tracking-[0.2em] text-[var(--color-amber)]">
              Illuminate Your Moments
            </p>
            <p className="mt-6 max-w-sm text-sm leading-relaxed font-light text-[var(--color-cream)]/55">
              Handcrafted eco-friendly candles made from all-natural vegan wax.
              Designed to evoke cherished memories and inspire new ones.
            </p>
          </div>
          <FooterCol
            title="Shop"
            links={[
              { label: "All Candles", to: "/collection" },
              { label: "New Arrivals", to: "/collection" },
              { label: "Bestsellers", to: "/collection" },
              { label: "Gift Sets", to: "/collection" },
            ]}
          />
          <FooterCol
            title="Info"
            links={[
              { label: "Our Craft", to: "/craft" },
              { label: "Create Your Candle", to: "/create" },
              { label: "Contact Us", to: "/contact" },
              { label: "Instagram", to: "https://www.instagram.com/bead0re/" },
            ]}
          />
          <FooterCol
            title="Policies"
            links={[
              { label: "Terms of Service", to: "/terms" },
              { label: "Privacy Policy", to: "/privacy" },
              { label: "Refund Policy", to: "/refunds" },
              { label: "Contact", to: "mailto:hello@beadorecandles.com" },
            ]}
          />
        </div>
        <div className="mt-16 flex flex-col items-center gap-4 border-t border-white/10 pt-8 md:flex-row md:justify-between">
          <p className="text-[0.7rem] uppercase tracking-[0.18em] text-[var(--color-cream)]/30">
            © {new Date().getFullYear()} BeAdoré · All rights reserved · Made
            in the United States
          </p>
          <div className="flex gap-3">
            {["Vegan", "Eco-Certified", "Small Batch"].map((b) => (
              <span
                key={b}
                className="border border-white/10 px-3 py-1 text-[0.6rem] uppercase tracking-[0.12em] text-[var(--color-cream)]/40"
              >
                {b}
              </span>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}

function FooterCol({
  title,
  links,
}: {
  title: string;
  links: { label: string; to: string }[];
}) {
  return (
    <div>
      <p className="text-[0.65rem] font-medium uppercase tracking-[0.18em] text-[var(--color-cream)]/40">
        {title}
      </p>
      <ul className="mt-5 flex flex-col gap-3">
        {links.map((l) => (
          <li key={l.label}>
            <a
              href={l.to}
              className="text-sm font-light text-[var(--color-cream)]/60 transition-colors hover:text-[var(--color-amber)]"
            >
              {l.label}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}
